/* eslint-disable import/prefer-default-export */

const BASE_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:4000';
const BASE_POST_URL = process.env.REACT_APP_EVALUATOR_API_URL || 'http://localhost:4000';

const AUTH_TOKEN = '396c63ad45e04e869f14b97819a3eb06';

const ALLOWED_ENDPOINTS = ['/project', '/unified-chargers', '/commercial/vehicles', '/location'];

// GET request
export async function getData(endpoint) {
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${AUTH_TOKEN}`,
    },
  });
  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }
  return response.json();
}

// POST request
export async function postData(endpoint, data) {
  if (!ALLOWED_ENDPOINTS.includes(endpoint)) {
    throw new Error('Endpoint not allowed');
  }
  const response = await fetch(`${BASE_POST_URL}${endpoint}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${AUTH_TOKEN}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }
  return response.json();
}
